<template lang='pug'>
  b-nav-item-dropdown(right='', no-caret='')
    template(slot='button-content')
      i.icon-bell
      b-badge(pill='', variant='danger') {{itemsCount}}
    b-dropdown-header.dropdown-menu-lg.text-center(tag='div')
      strong You have {{itemsCount}} notifications
    b-dropdown-item
      i.icon-user-follow.text-success
      |  New user registered
    b-dropdown-item
      i.icon-user-unfollow.text-danger
      |  User deleted
    b-dropdown-item
      i.icon-chart.text-info
      |  Sales report is ready
    b-dropdown-item
      i.icon-basket-loaded.text-primary
      |  New client
    b-dropdown-item
      i.icon-speedometer.text-warning
      |  Server overloaded
    b-dropdown-header.text-center(tag='div')
      strong Server
    b-dropdown-item
      .text-uppercase.mb-1
        small
          b CPU Usage
      b-progress.progress-xs(height='{}', variant='info', :value='25')
        small.text-muted 348 Processes. 1/4 Cores.
    b-dropdown-item
      .text-uppercase.mb-1
        small
          b Memory Usage
      b-progress.progress-xs(height='{}', variant='warning', :value='70')
        small.text-muted 11444GB/16384MB
    b-dropdown-item
      .text-uppercase.mb-1
        small
          b SSD 1 Usage
      b-progress.progress-xs(height='{}', variant='danger', :value='90')
        small.text-muted 243GB/256GB
</template>
<script>
  export default {
    name: 'header-dropdown-notif',
    data: () => {
      return { itemsCount: 5 }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownNotif.vue